module.exports = __webpack_public_path__ + "static/img/bg2.cc3fe2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/app/bg2.png
// module id = mSZ7
// module chunks = 69